import ErrorBox from '@components/common/ErrorBox';
import Button from '@ui/button/Button';
import api from '@utils/api';
import { removeChatInfosFromStorage } from '@components/chat/ChatUtils';
import createDecorator from 'final-form-focus';
import React, { useRef } from 'react';
import { Form } from 'react-final-form';
import ReCAPTCHA from 'react-google-recaptcha';
import FormField from '@ui/formfield/FormField';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import analytics from '@utils/analytics';
import customEventBus from '@common/scripts/libs/eventBus';
import { addURLParameter } from '@common/utils/urlutils';
const focusOnError = createDecorator(); // must be outside the component
const RegisteredInStore = (props) => {
    const { t } = useTranslation();
    const [errors, setErrors] = React.useState([]);
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const reCaptchaRef = useRef();
    const showRecaptcha = window.recapchaCfg && JSON.parse(window.recapchaCfg).loginButton;
    const redirectAfterSuccess = new URLSearchParams(window.location.search).get('redirectToPdp');
    const onSubmit = async (values) => {
        setErrors([]);
        setIsSubmitting(true);
        values.loginEmail = props.loginEmail;
        if (showRecaptcha) {
            const token = await reCaptchaRef.current.executeAsync();
            values.gr3Token = token;
        }
        api
            .login(values, redirectAfterSuccess)
            .then((data) => {
            if (data.success) {
                (props === null || props === void 0 ? void 0 : props.updateLoggeedStatus) && (props === null || props === void 0 ? void 0 : props.updateLoggeedStatus(data.authenticatedCustomer));
                removeChatInfosFromStorage();
                analytics.login();
                if ((props === null || props === void 0 ? void 0 : props.linkreload) && !props.reloadComponent) {
                    window.location.href = props.linkreload;
                }
                else if (props.reloadComponent) {
                    window.loggedin = true;
                    customEventBus.emit('account:update', {});
                }
                else if (data.redirectUrl && !props.reloadPageRegisteredInStore) {
                    window.location.replace(data.redirectUrl);
                }
                else {
                    window.location.reload();
                }
            }
            if (data.error && data.error.length > 0) {
                if (data.error[0] == 'migration') {
                    window.location.href = addURLParameter(props.forgotpasswordform, 'migration', 'true');
                }
                else {
                    setErrors(data.error);
                    setIsSubmitting(false);
                }
            }
        })
            .catch((e) => {
            setErrors([e]);
            setIsSubmitting(false);
        });
    };
    const sendEmail = () => {
        api.forgotPasswordSendMail(props.loginEmail);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "primary-xs", dangerouslySetInnerHTML: { __html: t('login.registeredinstore.title', { 0: props.loginEmail }) } }),
        React.createElement("div", { className: "row mt-24" },
            React.createElement("p", { className: "primary-xs" },
                t('login.clothing.sendagaintext'),
                "\u00A0"),
            React.createElement("button", { className: "link primary-xs", onClick: () => sendEmail() }, t('login.clothing.sendagain'))),
        React.createElement("p", { className: "mt-32 primary-xs" }, t('login.registeredinstore.subtitle')),
        React.createElement(Form, { onSubmit: onSubmit, decorators: [focusOnError], render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: handleSubmit, className: "mt-24" },
                React.createElement("div", { className: classNames('formfields', { 'has-password-error': errors.length >= 1 }) },
                    React.createElement(FormField, { name: "loginPassword", label: t('label.password'), type: "password", autocomplete: "current-password", showPassword: true, required: true }),
                    React.createElement("div", { className: "forgot-pw-error" },
                        React.createElement("div", { className: "forgot-pw-error__pw" },
                            React.createElement("a", { className: classNames('button', 'forgot-pw'), href: props.forgotpasswordform || window.forgotpasswordform, onClick: () => analytics.forgotPasswordOne() }, t('login.forgottenpassword'))),
                        React.createElement("div", { className: "forgot-pw-error__error" },
                            React.createElement(ErrorBox, { errors: errors }))),
                    !window.clickfromstore && (React.createElement("div", { className: "remember-me" },
                        props.rememberme && React.createElement(FormField, { name: "loginRememberMe", label: t('label.rememberme'), type: "checkbox", checked: true }),
                        React.createElement("a", { href: props.privacypolicy || window.privacypolicyurl, target: "_blank", rel: "noreferrer", className: "privacy-link" }, t('login.privacypolicy'))))),
                showRecaptcha && React.createElement(ReCAPTCHA, { className: "recaptcha", sitekey: window.atob(window.recapchaData), size: "invisible", ref: reCaptchaRef }),
                React.createElement(Button, { type: "submit", disabled: isSubmitting, cls: ['button--primary'] }, t('login.logintomymoncler')))) })));
};
export default RegisteredInStore;
